<template>
  <div
    class="quorum-approver-group-card"
    data-test-id="quorum-approver-group-card"
  >
    <div class="quorum-approver-group-card__cards">
      <InviteeCard
        v-for="signee in group"
        :key="signee.signeeId"
        :participant="signee"
      />
    </div>

    <div
      class="text-body-2 quorum-approver-group-card__summary d-flex align-center"
      :style="{ fontSize: '14px' }"
    >
      <span class="text-grey ml-1">{{ summaryText }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import InviteeCard from '@/components/create/InviteeCard.vue';
import { useCreateStore } from '@/stores/create.ts';
import type { Signee } from '@/types/Signee.ts';

const props = defineProps({
  group: {
    type: Array as PropType<Signee[]>,
    required: true
  }
});

const i18n = useI18n();
const createStore = useCreateStore();

const total = computed(() => props.group.length);
const quorum = computed(() => createStore.getGroupQuorum(props.group));

const summaryText = computed(() =>
  i18n.t(
    'texts.quorum_need_to_approve',
    {
      required: quorum.value,
      total: total.value
    },
    quorum.value ?? 1
  )
);
</script>

<style scoped lang="scss">
.quorum-approver-group-card {
  grid-column: 1 / -1;
  min-width: 0;
}

.quorum-approver-group-card__cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.quorum-approver-group-card__summary {
  height: 24px;
}
</style>
